import { render, staticRenderFns } from "./ReadyToMeal.vue?vue&type=template&id=604d1c32&scoped=true&"
import script from "./ReadyToMeal.vue?vue&type=script&lang=js&"
export * from "./ReadyToMeal.vue?vue&type=script&lang=js&"
import style0 from "./ReadyToMeal.vue?vue&type=style&index=0&id=604d1c32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604d1c32",
  null
  
)

export default component.exports